module.exports = __webpack_public_path__ + "img/add_more.2e1fb892.svg";